import "antd/dist/reset.css";
import'./assets/scss/App.scss';

import { useEffect } from "react";
import { notification, Button } from "antd";

//imoprt Route
import RoutesComponents from "./Routes/index";
import { ThemeProvider as CustomThemeProvider } from "./Common/ThemeContext";
import useVersionCheck from "./helpers/useVersionCheck";


// import fakeBackend from "./helpers/AuthType/fakeBackend";

// // Activating fake backend
// fakeBackend();

// Shows a persistent prompt when a newer build has been deployed while the tab
// is open. We don't force a reload so the user is never interrupted mid-edit.
const VersionBanner = () => {
  const newVersionAvailable = useVersionCheck();
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    if (!newVersionAvailable) return;
    api.info({
      key: "new-version",
      message: "A new version is available",
      description: "Reload to get the latest updates.",
      duration: 0,
      placement: "bottomRight",
      btn: (
        <Button type="primary" size="small" onClick={() => window.location.reload()}>
          Reload
        </Button>
      ),
    });
  }, [newVersionAvailable, api]);

  return contextHolder;
};

const App = () => {
  return (
    <CustomThemeProvider>
      <VersionBanner />
      <RoutesComponents />
    </CustomThemeProvider>
  )
}

export default App;
